import { render, staticRenderFns } from "./ConfirmJoined.vue?vue&type=template&id=b2bdd076"
import script from "./ConfirmJoined.vue?vue&type=script&lang=js"
export * from "./ConfirmJoined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports